module.exports = __webpack_public_path__ + "resource/img/japan.png?a15d9a012ac07c95654b4221887ff202";


//////////////////
// WEBPACK FOOTER
// ./src/images/japan.png
// module id = 646
// module chunks = 0 2